import React, { useState, useEffect } from "react";
import "./Sidebar.css";
import Premium from "./Premium";
import sidebarIcon from "../assets/sidebar.png";
import newChatIcon from "../assets/newchat.png";
import searchIcon from "../assets/search.png";
import logoutIcon from "../assets/logout.png";

function Sidebar({
  chats,
  onNewChat,
  onSelectChat,
  selectedChatId,
  onLogout,
  onRenameChat = () => {},
  onDeleteChat = () => {},
}) {
  const [isExpanded, setIsExpanded] = useState(window.innerWidth > 768);
  const [searchTerm, setSearchTerm] = useState("");
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [editingChatId, setEditingChatId] = useState(null);
  const [chatNameInput, setChatNameInput] = useState("");
  const [menuOpenId, setMenuOpenId] = useState(null);
  const [showPremium, setShowPremium] = useState(false); // ✅ for popup

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      setIsExpanded(!mobile);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const filteredChats = chats.filter((chat) =>
    chat.title?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const commitRename = async (chatId) => {
    if (chatNameInput.trim() && chatId !== null) {
      await onRenameChat(chatId, chatNameInput.trim());
    }
    setEditingChatId(null);
    setChatNameInput("");
  };

  return (
    <>
      {/* Floating toggle button for mobile when sidebar is collapsed */}
      {isMobile && !isExpanded && (
        <button
          className="toggle-btn mobile-toggle"
          onClick={() => setIsExpanded(true)}
          title="Open Sidebar"
        >
          <img src={sidebarIcon} alt="Sidebar Toggle" />
        </button>
      )}

      <div className={`sidebar ${isExpanded ? "expanded" : "collapsed"}`}>
        <div className="sidebar-header">
          <button
            className="toggle-btn"
            onClick={() => setIsExpanded((prev) => !prev)}
            title="Toggle Sidebar"
          >
            <img src={sidebarIcon} alt="Toggle Icon" />
          </button>

          {isExpanded && <h2 className="sidebar-title">StratXcel</h2>}
        </div>

        {isExpanded && (
          <div className="sidebar-content">
            <button className="new-chat-btn" onClick={onNewChat}>
              <img src={newChatIcon} alt="New Chat" />
              New Chat
            </button>

            {/* ✅ Premium Button */}
            <button
              className="new-chat-btn"
              onClick={() => setShowPremium(true)}
            >
              ⭐ Premium
            </button>

            <div className="search-container">
              <img src={searchIcon} alt="Search" className="search-icon" />
              <input
                type="text"
                placeholder="Search chats..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="search-bar"
              />
            </div>

            <div className="chat-list">
              {filteredChats.map((chat) => (
                <div
                  key={chat.id}
                  className={`chat-item ${
                    chat.id === selectedChatId ? "active" : ""
                  }`}
                  onMouseLeave={() => setMenuOpenId(null)}
                >
                  {editingChatId === chat.id ? (
                    <input
                      type="text"
                      value={chatNameInput}
                      onChange={(e) => setChatNameInput(e.target.value)}
                      onBlur={() => commitRename(chat.id)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") commitRename(chat.id);
                        if (e.key === "Escape") {
                          setEditingChatId(null);
                          setChatNameInput("");
                        }
                      }}
                      autoFocus
                    />
                  ) : (
                    <div
                      className="chat-title-row"
                      onClick={() => onSelectChat(chat.id)}
                    >
                      <span className="chat-title">
                        {chat.title || "Untitled"}
                      </span>
                      <button
                        className="more-btn"
                        onClick={(e) => {
                          e.stopPropagation();
                          setMenuOpenId(
                            menuOpenId === chat.id ? null : chat.id
                          );
                        }}
                      >
                        ⋯
                      </button>

                      {menuOpenId === chat.id && (
                        <div className="dropdown-menu">
                          <div
                            className="dropdown-item"
                            onClick={(e) => {
                              e.stopPropagation();
                              setEditingChatId(chat.id);
                              setChatNameInput(chat.title);
                              setMenuOpenId(null);
                            }}
                          >
                            Rename
                          </div>
                          <div
                            className="dropdown-item"
                            onClick={(e) => {
                              e.stopPropagation();
                              onDeleteChat(chat.id);
                              setMenuOpenId(null);
                            }}
                          >
                            Delete
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              ))}
            </div>

            <div className="logout-container">
              <button className="logout-btn" onClick={onLogout}>
                <img src={logoutIcon} alt="Logout" />
                Logout
              </button>
            </div>
          </div>
        )}
      </div>

      {/* ✅ Show Premium Popup */}
      {showPremium && <Premium onClose={() => setShowPremium(false)} />}
    </>
  );
}

export default Sidebar;
